/* eslint-disable react/prop-types */
import React from 'react';
import FormDataJson from 'form-data-json-convert';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { mutateImageUrl } from '../../../wordpress';
import ProductWarningText from './ProductWarningText';

const ProductVariant = ({
    parentProduct,
    product,
    section,
    isSelected,
    onSelect,
    onRemove,
    onCustomise,
    projectTitle,
    boldProductOptions,
}) => {
    const prodIdParsed = product && product.id.split('/').pop();
    const classes = classNames('product', { 'product-selected': isSelected, 'product-sale': product.on_sale });
    const imgSrc = mutateImageUrl(product.image && product.image.url, 480, 480);
    const isCustomisable = boldProductOptions && boldProductOptions[1]?.option_sets?.length > 0;

    let button = (
        <button
            type="button"
            className="btn button span"
            onClick={(e) => {
                const productFormJsonValues = FormDataJson.toJson(e.target.form);
                onSelect(parentProduct, '', '', product, productFormJsonValues);
            }}
        >
            <span>Add</span>
        </button>
    );

    const hasReverseImage = product?.reverseImage?.reference?.image?.url;
    if (isSelected) {
        button = (
            <button type="button" className="btn button span inverse" onClick={() => onRemove(section)}>
                <span>Remove</span>
            </button>
        );
    } else if (isCustomisable || product.variants?.nodes?.length > 1 || hasReverseImage) {
        button = (
            <button
                type="button"
                className="btn button span"
                onClick={() => onCustomise(section === 'heads' ? parentProduct : product)}
            >
                <span>{hasReverseImage && !isCustomisable ? 'View' : 'Customise'}</span>
            </button>
        );
    }

    return (
        <li className={classes} key={product.id}>
            <button
                type="button"
                className="product-customise"
                onClick={() => {
                    onCustomise(parentProduct);
                }}
            >
                {imgSrc ? (
                    <img src={imgSrc} width="480" height="480" alt="" loading="lazy" />
                ) : (
                    <span className="image-placeholder" />
                )}
            </button>

            <ProductWarningText product={parentProduct} />

            <span className="product-title">
                <form
                    action="/cart/add"
                    method="post"
                    encType="multipart/form-data"
                    id={`AddToCartForm-${prodIdParsed}`}
                >
                    <input type="number" name="quantity" value="1" hidden readOnly />
                    <input name="id" value={product.id.split('/').pop()} hidden readOnly />
                    <input
                        type="text"
                        id={`projectTitle-${product.id.split('/').pop()}`}
                        name="properties[projectTitle]"
                        value={projectTitle ? projectTitle : ''}
                        hidden
                        readOnly
                    />

                    {!product.availableForSale ? (
                        <p className="btn button span disabled">
                            <span>Sold out</span>
                        </p>
                    ) : (
                        button
                    )}
                </form>

                {parentProduct.title.split('-')[0]}
            </span>

            <span
                className="product-price"
                dangerouslySetInnerHTML={{
                    __html: `£${product.priceV2.amount}`,
                }}
            />
        </li>
    );
};

ProductVariant.propTypes = {
    product: PropTypes.object.isRequired,
    isSelected: PropTypes.bool,
    onSelect: PropTypes.func,
    onRemove: PropTypes.func,
    onCustomise: PropTypes.func,
};

ProductVariant.defaultProps = {
    isSelected: false,
    onSelect: () => {},
    onRemove: () => {},
    onCustomise: () => {},
};

export default ProductVariant;
